<template>
  <div class="dialog-container wt-dialog-container ">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list ref="goodsTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="isPublish" slot-scope="data">
          <span class="publish-status" v-if="data.row.isPublish*1 === 1">已上架</span>
          <span class="normal-status" v-else>未上架</span>
        </template>
        <template slot="saleType" slot-scope="data">
          <span v-if="data.row.saleType*1 === 1">自提</span>
          <span v-if="data.row.saleType*1 === 2">售货柜</span>
        </template>
        <template slot="cover" slot-scope="data">
          <img class="table-img" v-if="data.row.cover && data.row.cover.length > 0" :src="imgUrl + data.row.cover.split(',')[0]">
        </template>
        <template slot="suspensionPath" slot-scope="data">
          <img class="table-img" :src="imgUrl + data.row.suspensionPath">
        </template>
        <template slot="wtFormTableListButtonsBefore" slot-scope="data">
          <wt-auth v-if="data.row.isHot*1 === 1" class="search-form-btn">
            <el-button size="mini" @click="toHotClickAction(data.row)">取消热门</el-button>
          </wt-auth>
          <wt-auth v-if="data.row.isHot*1 !== 1" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toHotClickAction(data.row)">设为热门</el-button>
          </wt-auth>
          <wt-auth v-if="data.row.isPublish*1 === 1" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toPublishClickAction(data.row)">取消上架</el-button>
          </wt-auth>
          <wt-auth v-if="data.row.isPublish*1 !== 1" class="search-form-btn">
            <el-button size="mini" type="primary" @click="toPublishClickAction(data.row)">设置上架</el-button>
          </wt-auth>
        </template>
       </wt-form-table-list>
    </wt-form-table>
    <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'

export default {
  name: 'GoodsRecord',
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      detailFormButtons: {
        title: '兑换记录',
        elements: [{ name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_GOODS',
        formComponent: {
          list: { type: 'default', value: '/modules/goods/goodsExchangeList', params: { goodsId: 0 }}
        },
        formInputsData: [
          { name: '订单编号', key: 'goodsNo', value: '', type: 'text' },
          { name: '站点名称', key: 'goodsNo', value: '', type: 'text' },
          { name: '手机号', key: 'goodsNo', value: '', type: 'text' },
          { name: '下单时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [],
        formTableData: [
          { name: '订单编号', key: 'orderId', type: 'text' },
          { name: '商品名称', key: 'goodsName', type: 'text' },
          { name: '兑换积分', key: 'totalIntegral', type: 'text' },
          { name: '用户昵称', key: 'userName', type: 'text' },
          { name: '手机号', key: 'userPhone', type: 'text' },
          { name: '站点名称', key: 'siteName', type: 'text' },
          { name: '下单时间', key: 'createTime', type: 'text' },
          { name: '核销时间', key: 'exchangeTime', type: 'text' },
          { name: '核销人', key: '', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.goodsId = this.goodsId
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      }
    },
    onButtonAction(data) {
    },
    toPublishClickAction(row) {
      this.$wtUtil.deleteConfirm(this, row.isPublish === 1 ? '确认取消上架？' : '确认上架？').then(() => {
        request({
          url: '/modules/goods/goodsIsPublish',
          method: 'post',
          data: {
            id: row.id,
            state: row.isPublish === 1 ? 0 : 1
          }
        }).then(res => {
          if (res.code === '0') {
            this.$message({ message: '操作成功', type: 'success' })
            this.$refs.goodsTableRef.requestList()
          }
        })
      })
    },
    toHotClickAction(row) {
      this.$wtUtil.deleteConfirm(this, row.isHot === 1 ? '确认取消热门？' : '确认设置热门？').then(() => {
        request({
          url: '/modules/goods/goodsIsHot',
          method: 'post',
          data: {
            id: row.id,
            state: row.isHot === 1 ? 0 : 1
          }
        }).then(res => {
          if (res.code === '0') {
            this.$message({ message: '操作成功', type: 'success' })
            this.$refs.goodsTableRef.requestList()
          }
        })
      })
    }
  },
  computed: {
    ...mapState({
      goodsId: state => state.goods.goodsId
    })
  }
}
</script>
